import { Component, ElementRef, Inject, NgModule, ViewChild, OnInit } from '@angular/core';
import { Location, CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { PoliciesService } from 'src/app/shared/services/policyservices/policies.service';
import Swal from 'sweetalert2';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { FormsModule, NgForm } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
declare let $: any;
@Component({
  selector: 'app-setup-text-automation',
  templateUrl: './setup-text-automation.component.html',
  styleUrl: './setup-text-automation.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class SetupTextAutomationComponent implements OnInit {
  @ViewChild('edittextModal') edittextModal!: ElementRef;
  @ViewChild('setuptextModal') setuptextModal!: ElementRef;
  @ViewChild('deleteModal', { static: false }) deleteModal!: ElementRef;
  public showSpinner = false;
  selectedMode: any;
  gettype: any;
  user: any;
  userInfo: any;
  id: any;
  dataAutoTextforEdit: any = {};
  selectedData: any = null;
  refresh: any;
  constructor(
    public _location: Location,
    private sharedmode: SharedModeService,
    private policyService: PoliciesService,
    public router: Router,
    public dashboardService: DashboardService,
    private settings: SettingservicesService,
    private route: ActivatedRoute,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type == "Employee") {
      this.router.navigate(['/dashboard-1']);
    }

  }
  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getType();
    this.getTextForAutomation();
    this.user_refresh();

  }
  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

      localStorage.setItem('user', JSON.stringify(value.data.user));
      const test_user = localStorage.getItem("user");
      const user_role = JSON.parse(this.user.user_role.user_roles)

    })

  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value?.data;
      this.showSpinner = false;
    })
  }

  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.settings?.data?.values;

    switch (type) {
      case "view":
        return values?.view ?? false;
      case "add":
        return values?.add ?? false;
      case "edit":
        return values?.edit ?? false;
      case "delete":
        return values?.delete ?? false;
      default:
        return false;
    }
  }
  getType() {
    this.settings.getTypeHere().then((data) => {
      this.showSpinner = false;
      if (data.success == true) {
        this.gettype = data?.data
      }
    })

  }

  onSubmit(des: NgForm) {
    this.showSpinner = true;

    const data = {
      text: des.value.set_text,
      id: des.value.types.id,
      org_id: this.userInfo.organization_id
    };
    this.settings.createAutomationText(data).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Designation Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        $(this.setuptextModal.nativeElement).modal('hide');
        this.resetForm(des);
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    })


  }
  editAutoText(data: any) {
    const d = data;
    this.dataAutoTextforEdit = {
      id: d.id,
      title: d.title,
      text: d.text,
      typeid: d.type_id
    };
    const modalElement2 = this.edittextModal.nativeElement;
    $(modalElement2).modal('show');
  }

  onEditSubmit(des1: NgForm) {
    this.showSpinner = true;
    this.id = this.dataAutoTextforEdit.id;
    const data = {
      text: des1.value.set_text,
      id: des1.value.types,
      org_id: this.userInfo.organization_id
    };
    this.settings.editAutomationText(data, this.id).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'AutomationText Edit Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.resetForm(des1);
      } else {

        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    })
  }



  resetForm(form: NgForm) {
    form.resetForm();
    this.selectedData = null;
    $(this.setuptextModal.nativeElement).modal('hide');
    $(this.edittextModal.nativeElement).modal('hide');
    this.getTextForAutomation();
    this.showSpinner = false;
  }
  gettextauto: any;
  getTextForAutomation() {
    this.showSpinner = true;
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data
      this.showSpinner = false;
    })
  }
  selectedId: any;
  setDeleteId(id: number) {
    this.selectedId = id;
  }
  deleteAutomationtext(data: any) {
    this.showSpinner = true;
    const id = data;
    this.settings.delTextAutomation(id).then((value) => {

    });

    if (this.deleteModal?.nativeElement) {
      $(this.deleteModal.nativeElement).modal('hide');
    }
    this.getTextForAutomation();

    this.showSpinner = false;

  }

}
